<div class="toast-container">
  <sgt-toast
    *ngFor="let toast of toasts$ | async; trackBy: trackById"
    [title]="toast.title"
    [message]="toast.message"
    [type]="toast.type"
    [duration]="toast.duration"
    [action]="toast.action"
    (closed)="toastService.close(toast.id)">
  </sgt-toast>
</div>
